import BrokerInformationEditor from 'components/Information/BrokerInformationItem'
import Information from 'components/Information/Information'
import Disclosure from 'components/Information/Disclosure'
import NormativeActs from 'components/Information/NormativeActs'
import Requisites from 'components/Information/Requisites'
import BrokerInformation from 'components/Information/BrokerInformation'
import BankRequirement from 'components/Information/BankRequirement'
import ToDeponents from 'components/Information/ToDeponents'

export default {
  children: [
    {
      path: 'list',
      name: 'Information',
      component: Information
    }, {
      path: 'disclosure',
      name: 'Disclosure',
      component: Disclosure
    }, {
      path: 'normative-acts',
      name: 'NormativeActs',
      component: NormativeActs
    }, {
      path: 'requisites',
      name: 'Requisites',
      component: Requisites
    }, {
      path: 'bank-requirements',
      name: 'BankRequirement',
      component: BankRequirement
    }, {
      path: 'to-deponents',
      name: 'ToDeponents',
      component: ToDeponents
    }, {
      path: 'notifications',
      name: 'BrokerInformation',
      component: BrokerInformation
    }, {
      path: 'notifications/edit/:id',
      name: 'BrokerInformationEditor',
      component: BrokerInformationEditor
    }, {
      path: 'notifications/create',
      name: 'BrokerInformationCreator',
      component: BrokerInformationEditor
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/InformationContainerRoutes.js